import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"
import "./desktop_component.css"

export default class extends Controller {
  static targets = [
    "projectsContainer",
    "projectsMenu",
    "projectsToggle"
  ]

  connect() {
    useClickOutside(this, { element: this.projectsContainerTarget })
  }

  toggleProjects(event) {
    event?.preventDefault()
    if (!this.hasProjectsMenuTarget) return

    if (this.projectsMenuTarget.classList.contains("hidden")) {
      this.openProjectsMenu()
    } else {
      this.closeProjects()
    }
  }

  openProjectsMenu() {
    if (!this.hasProjectsMenuTarget) return

    this.projectsMenuTarget.classList.remove("hidden")
    this.setProjectsExpandedState(true)
  }

  closeProjects() {
    if (!this.hasProjectsMenuTarget) return

    this.projectsMenuTarget.classList.add("hidden")
    this.setProjectsExpandedState(false)
  }

  clickOutside(event) {
    if (!this.hasProjectsMenuTarget) return

    if (!this.projectsMenuTarget.classList.contains("hidden")) {
      this.closeProjects()
    }
  }

  handleEscape(event) {
    if (!this.hasProjectsMenuTarget) return

    if (!this.projectsMenuTarget.classList.contains("hidden")) {
      this.closeProjects()
    }
  }

  setProjectsExpandedState(expanded) {
    if (this.hasProjectsToggleTarget) {
      this.projectsToggleTarget.setAttribute("aria-expanded", String(expanded))
    }
  }
}
